import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { BaseSiteService, RoutingService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomRegistrationService } from '../../custom-registration.service';
@Component({
    selector: 'app-account-header',
    templateUrl: './account-header.component.html',
    styleUrls: ['./account-header.component.scss'],
    standalone: false
})
export class AccountHeaderComponent implements OnInit, OnDestroy {
  @Input() selectedHeader: string;
  @Input() tableCategory: string;
  header: string;
  formData: any;
  twoFormsData: any[];
  baseSiteId: string;
  baseSub: Subscription;
  accSub: Subscription;

  constructor(
    private readonly accountRegService: CustomRegistrationService,
    private readonly cdr: ChangeDetectorRef,
    private readonly route: RoutingService,
    private readonly baseSiteService: BaseSiteService
  ) {}

  ngOnInit(): void {
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));

    this.accSub = this.accountRegService.sectionChange.subscribe(
      (sectionDetails) => {
        this.header = sectionDetails.header;
        if (!!sectionDetails?.form) {
          this.formData = sectionDetails.form;
        }
        if (!!sectionDetails?.forms) {
          this.twoFormsData = sectionDetails.forms;
        }
        if (sectionDetails.header === 'contacts') {
          this.formData = sectionDetails?.totalFormData;
        }
        this.cdr.detectChanges();
      }
    );
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
    this.accSub?.unsubscribe();
  }
  gotoAdduser() {
    if (!this.baseSiteId) {
      console.error('baseSiteId is undefined');
      return;
    }
    const targetUrl = `/${this.baseSiteId}/en/USD/customer-register`;
    window.location.href = targetUrl;
  }
}
